import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getVehicleType from '../../services/vehicleType/getVehicleType'
import { showLoader, hideLoader } from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchCombosSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'

export function * fetchVehicleType () {
  try {
    yield put(showLoader())
    const auth = yield select(getAuth)
    const vehicletypeCombo = yield call(getVehicleType, auth.token)
    const vehicleType = vehicletypeCombo
    yield put(fetchCombosSuccess({ vehicletypeCombo, vehicleType }))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchFetchVehicleType () {
  yield takeLatest(combosActionTypes.FETCH_VEHICLETYPE, fetchVehicleType)
}
